import { useState } from "react";
import { LocationRead } from "@types";

export function useManageLocation() {
  const [locations, setLocations] = useState<LocationRead | null>(null);
  const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const toggleSideBar = () => {
    setLocations(null);
    setIsSideBarOpen((prev) => !prev);
  };

  const selectCouponsToEdit = (Location: LocationRead) => {
    setIsSideBarOpen(true);

    setLocations(Location);
  };

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setLocations(null);
  };

  const handleRowClick = (rowData: { data: LocationRead }) => {
    setLocations(rowData.data);
    setIsDetailsModalOpen(true);
  };

  return {
    locations,
    isSideBarOpen,
    isDetailsModalOpen,
    setLocations,
    handleRowClick,
    toggleSideBar,
    selectCouponsToEdit,
    handleCloseDetailsModal,
  };
}
